export default __webpack_public_path__ + "static/media/5-friend-icon.61249739.svg";